import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import { useLocation } from "react-router-dom";
import DataDeletionVerifiedMain from "./DataDeletionVerifiedMain";
import { trackEvent } from "../../../services/GoogleAnalytics";

export default function DataDeletionVerifiedPage() {
    const location = useLocation();

    useEffect(() => {
        trackEvent("entered", {
            name: "DataDeletionVerifiedPage",
            path: location.pathname,
        });
    }, [location.pathname]);

    return (
        <Box
            sx={{
                width: "100%",
                minHeight: "100vh",
            }}
        >
            <DataDeletionVerifiedMain />
        </Box>
    );
}
